function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.997 7.432A5.044 5.044 0 0114.024 2h.203a5.044 5.044 0 015.028 5.432l-.243 3.158a4.889 4.889 0 01-.577 1.96c.804.358 1.895.877 3.026 1.493.49.266.914.639 1.233 1.09a8.06 8.06 0 00-2.854.334 40.278 40.278 0 00-2.79-1.319 4.881 4.881 0 01-2.924.97 4.881 4.881 0 01-2.924-.97c-.736.31-2.06.912-3.448 1.668-.497.27-.789.736-.805 1.23-.044 1.36.054 3.471.598 5.924a1.01 1.01 0 01-1.968.438c-.586-2.635-.695-4.918-.646-6.428.042-1.28.797-2.36 1.858-2.937a43.735 43.735 0 013.026-1.493 4.89 4.89 0 01-.577-1.96l-.243-3.158zm5.027-3.414h.203a3.026 3.026 0 013.017 3.26L17 10.434a2.884 2.884 0 01-5.75 0l-.243-3.158a3.026 3.026 0 013.017-3.259z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.19 19.585l.663 2.04a.2.2 0 00.19.139h2.146a.2.2 0 01.117.362l-1.735 1.26a.2.2 0 00-.073.224l.663 2.04a.2.2 0 01-.308.224l-1.736-1.26a.2.2 0 00-.235 0l-1.735 1.26a.2.2 0 01-.308-.223l.663-2.04a.2.2 0 00-.073-.224l-1.735-1.261a.2.2 0 01.117-.362h2.146a.2.2 0 00.19-.138l.663-2.04a.2.2 0 01.38 0z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.193 16.378a6.809 6.809 0 00-6.807 6.811A6.809 6.809 0 0022.194 30C25.953 30 29 26.95 29 23.19a6.809 6.809 0 00-6.807-6.812zM16.9 23.19a5.296 5.296 0 015.294-5.297 5.296 5.296 0 015.294 5.297 5.296 5.296 0 01-5.294 5.297A5.296 5.296 0 0116.9 23.19z",
  fill: "currentColor"
})));